<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <form (ngSubmit)="saveDetails()" [formGroup]="propertyDetailsForm" *ngIf="dataToFormInitDetails && isView"
    #formElementRef>
    <div class="row">
      <div class="card">
        <div class="card-header border-0 align-items-center d-flex py-0">
          <h4 class="card-title mb-0 flex-grow-1"></h4>
          <div class="dropdown">
            <button class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
              type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
              <i class=" ri-settings-2-line fs-14"></i>
            </button>
            <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
              style="min-width: 22rem;">
              <div class="d-flex flex-column gap-2 filter-check">

                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-price"
                    formControlName="hidePrice" #inputRefp>
                  <label class="form-check-label" for="hide-price">
                    {{ 't-m-properties.t-hide-price'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-price-value"
                    formControlName="hidePriceValue" #inputRefp>
                  <label class="form-check-label" for="hide-price-value">
                    {{ 't-m-properties.t-hide-condo-value'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-energetic-certification"
                    formControlName="hideECNumber" #inputRefp>
                  <label class="form-check-label" for="hide-energetic-certification">
                    {{ 't-m-properties.t-hide-energetic-certification-number'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-ec-expiration-date"
                    formControlName="hideECExpirationDate" #inputRefp>
                  <label class="form-check-label" for="hide-ec-expiration-date">
                    {{ 't-m-properties.t-hide-energetic-certification-expiration-date'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-renewable-energy"
                    formControlName="hideRenewableEnergy" #inputRefp>
                  <label class="form-check-label" for="hide-renewable-energy">
                    {{ 't-m-properties.t-hide-renewable-energy'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-carbon-emission"
                    formControlName="hideCarbonEmissions" #inputRefp>
                  <label class="form-check-label" for="hide-carbon-emission">
                    {{ 't-m-properties.t-hide-carbon-emission'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-use-license"
                    formControlName="hideUseLicense" #inputRefp>
                  <label class="form-check-label" for="hide-use-license">
                    {{ 't-m-properties.t-hide-use-license'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-date-license"
                    formControlName="hideDateLicense" #inputRefp>
                  <label class="form-check-label" for="hide-date-license">
                    {{ 't-m-properties.t-hide-date-license'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-technical-sheet-license"
                    formControlName="hideTechnicalSheetLicense" #inputRefp>
                  <label class="form-check-label" for="hide-technical-sheet-license">
                    {{ 't-m-properties.t-hide-technical-sheet-license'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-building-license"
                    formControlName="hideBuildingLicense" #inputRefp>
                  <label class="form-check-label" for="hide-building-license">
                    {{ 't-m-properties.t-hide-building-license'| translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-exclusive"
                    formControlName="hideExclusive" #inputRefp>
                  <label class="form-check-label" for="hide-exclusive">
                    {{ 't-m-properties.t-hide-exclusive'| translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body py-0">
          <div class="row">
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="refereceInput" class="form-label">
                  {{ 't-m-properties.t-reference'| translate }} *
                </label>
                <input type="text" class="form-control" id="refereceInput" autocomplete="off"
                  placeholder="{{ 't-m-properties.t-placeholder-reference'| translate }}" required
                  formControlName="reference" [ngClass]="{ 
                                    'is-invalid': submitted && form['reference'].errors && (form['reference'].errors['required']  && dataToFormInitDetails?.checkAutoRef<1
                                || form['reference'].errors['warning']) 
                            }" #inputRefp [attr.disabled]="dataToFormInitDetails?.checkAutoRef>0?true:null" />
                <div
                  *ngIf="submitted && form['reference'].errors && form['reference'].errors['required'] && dataToFormInitDetails?.checkAutoRef<1"
                  class="invalid-feedback" align="left">
                  <div *ngIf="form['reference'].errors && form['reference'].errors['required']">
                    {{ 't-m-properties.t-reference'| translate }} {{ 't-general.t-is-required'|
                    translate }}
                  </div>
                </div>
                <div *ngIf="submitted && form['reference'].errors && form['reference'].errors['warning']"
                  class="warning-feedback" align="left">
                  <div *ngIf="form['reference'].errors && form['reference'].errors['warning']  ">
                    {{ 't-m-properties.t-reference'| translate }} {{ 't-exist'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="storeInput" class="form-label">{{'t-store' | translate}} *</label>
                <div class="select-ng" #ngselectRefp>
                  <ng-select [items]="stores" [multiple]="false" bindLabel="name" bindValue="id"
                    placeholder="{{'t-store-placeholder' | translate}}" required formControlName="store"
                    [ngClass]="{ 'is-invalid': submitted && form['store'].errors }" [clearable]="false"
                    (change)=" onChangeStore($event)">
                  </ng-select>
                </div>
                <div *ngIf="submitted && form['store'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['store'].errors['required']">
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="conditionInput" class="form-label">
                  {{ 't-m-properties.t-condition' | translate }}
                </label>
                <ng-select [items]="conditions" [multiple]="false" bindLabel="description" bindValue="id"
                  placeholder=" {{ 't-m-properties.t-placeholder-condition' | translate }}" required
                  formControlName="condition" [clearable]="false"
                  [ngClass]="{ 'is-invalid': submitted && form['condition'].errors && form['condition'].errors['required'] }"
                  [ngClass]="{ 'is-warning': submitted && form['condition'].errors && form['condition'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['condition'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['condition'].errors['required']">
                    {{ 't-m-properties.t-condition' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="businessTypeInput" class="form-label">
                  {{ 't-m-properties.t-business-type' | translate }}
                </label>
                <ng-select [items]="businessTypes" [multiple]="false" bindLabel="description" bindValue="id"
                  placeholder="  {{ 't-general.t-select' | translate }}   {{ 't-m-properties.t-business-type' | translate }}"
                  required formControlName="businessType" [clearable]="false"
                  [ngClass]="{ 'is-invalid': submitted && form['businessType'].errors && form['businessType'].errors['required']  }"
                  [ngClass]="{ 'is-warning': submitted && form['businessType'].errors && form['businessType'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['businessType'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['businessType'].errors['required']">
                    {{ 't-m-properties.t-business-type' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-3">
              <div class="mb-3">
                <div class="row">
                  <div
                    [ngClass]="form['businessStatus'].value && ((form['businessStatus'].value === saleId) || (rentIds && form['businessStatus'].value && rentIds.includes(form['businessStatus'].value))) ? 'col-lg-11' : 'col-lg-12'">
                    <label for="businessstatusInput" class="form-label">
                      {{ 't-m-properties.t-business-status' | translate }} <span
                        *ngIf="canChangeBusinessStatus === false"
                        ngbTooltip="{{'t-business-status-disabled-proposals' | translate}}" container="body"
                        class="ms-1 rounded-circle badge badge-soft-primary">?</span>
                      <span
                        *ngIf="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress"
                        ngbTooltip="{{'t-new-sales.t-properties-warning' | translate}}" container="body"
                        class="ms-1 rounded-circle badge badge-soft-primary">?</span>
                    </label>
                    <ng-select
                      *ngIf="!property || (property && (form['businessStatus'].value !== saleId && !rentIds.includes(form['businessStatus'].value))) || (property && (form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && !property?.saleInProgress)"
                      [multiple]="false" (change)="businessChange()" placeholder="Select business status" required
                      formControlName="businessStatus" [clearable]="false"
                      [ngClass]="{ 'is-invalid': submitted && form['businessStatus'].errors  && form['businessStatus'].errors['required']  }"
                      [ngClass]="{ 'is-warning': submitted && form['businessStatus'].errors && form['businessStatus'].errors['warning'] }">
                      <ng-option
                        [disabled]="(!permissionsService.checkMasterPermission('SELL_PROPERTIES', property?.store?.id) && !permissionsService.checkAgentPermission(property?.mainAgent, 'SELL_PROPERTIES')) && (item.id == saleId || (rentIds && rentIds.includes(item.id)))"
                        *ngFor="let item of businessStatus" [value]="item.id">{{item.description}}</ng-option>
                    </ng-select>
                    <ng-select
                      *ngIf="property && (form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress"
                      [multiple]="false" (change)="businessChange()" placeholder="Select business status" required
                      formControlName="businessStatus" [clearable]="false"
                      [ngClass]="{ 'is-invalid': submitted && form['businessStatus'].errors  && form['businessStatus'].errors['required']  }"
                      [ngClass]="{ 'is-warning': submitted && form['businessStatus'].errors && form['businessStatus'].errors['warning'] }">
                      <ng-option [disabled]="item.id !== saleId && !rentIds.includes(item.id)"
                        *ngFor="let item of businessStatus" [value]="item.id">{{item.description}}</ng-option>
                    </ng-select>
                    <div *ngIf="submitted && form['businessStatus'].errors" class="invalid-feedback" align="left">
                      <div *ngIf="form['businessStatus'].errors['required']">
                        {{ 't-m-properties.t-business-status' | translate }}
                        {{ 't-general.t-is-required'|translate }}
                      </div>
                    </div>
                  </div>
                  <div class="align-self-lg-center col-lg-1 ps-0" *ngIf="form['businessStatus'].value === saleId">
                    <div class="dropdown mt-4">
                      <button (click)="openModal(content)"
                        class="btn btn-outline-primary btn-sm dropdown waves-effect waves-primary border-input-custom"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"
                        #inputRefp>
                        <i class=" ri-more-2-fill fs-14"></i>
                      </button>
                    </div>
                  </div>
                  <div class="align-self-lg-center col-lg-1 ps-0"
                    *ngIf="rentIds && form['businessStatus'].value && rentIds.includes(form['businessStatus'].value)">
                    <div class="dropdown mt-4">
                      <button (click)="openModal(contentRent)"
                        class="btn btn-outline-primary btn-sm dropdown waves-effect waves-primary border-input-custom"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"
                        #inputRefp>
                        <i class=" ri-more-2-fill fs-14"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <label for="exclusiveInput" class="form-label">
                {{'t-properties-details.t-exclusivity' | translate}}
              </label>
              <ng-select id="exclusiveInput" formControlName="exclusive" [clearable]="false">
                <ng-option [value]="false">{{'t-properties-details.t-no-exclusive' |
                  translate}}</ng-option>
                <ng-option [value]="true">{{'t-properties-details.t-exclusive' | translate}}</ng-option>
              </ng-select>
            </div>
            <!--end col-->
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="yearofconstructionInput" class="form-label">

                  {{ 't-m-properties.t-year-of-construction' | translate }}
                </label>
                <input type="text" class="form-control" id="yearofconstructionInput"
                  formControlName="yearOfConstruction" mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-year-of-construction' | translate }}"
                  [dateFormat]="'d/m/Y'" #inputRefp>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mb-3">
                <label class="form-label">
                  {{'t-developments.t-show-year' | translate}}
                </label>
                <ng-select [items]="formats" [multiple]="false" bindLabel="description" bindValue="id"
                  formControlName="yearType" [clearable]="false">
                </ng-select>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="expectedConstructionStartInput" class="form-label">
                  {{ 't-m-properties.t-expected-construction-start-date' | translate }}
                </label>
                <input type="text" class="form-control" id="expectedConstructionStartInput"
                  formControlName="expectedConstructionStartDate" mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-expected-construction-start-date' | translate }}"
                  [dateFormat]="'d/m/Y'" #inputRefp>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="expectedConstructionEndInput" class="form-label">
                  {{ 't-m-properties.t-expected-construction-end-date' | translate }}
                </label>
                <input type="text" class="form-control" id="expectedConstructionEndInput"
                  formControlName="expectedConstructionEndDate" mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-expected-construction-end-date' | translate }}"
                  [dateFormat]="'d/m/Y'" #inputRefp>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-12">
              <div class="row" *ngIf="isShowUseLicense">
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="useLicenseInput" class="form-label">
                      {{ 't-m-properties.t-use-license' | translate }}
                    </label>
                    <input type="text" class="form-control" id="useLicenseInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-use-license' | translate }} "
                      formControlName="useLicense" #inputRefp />

                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="dateLicenseInput" class="form-label">
                      {{ 't-m-properties.t-date-license' | translate }}
                    </label>
                    <input class="form-control flatpickr-input" type="text"
                      placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-date-license' | translate }}"
                      mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true" [dateFormat]="'d/m/Y'" formControlName="dateLicense"
                      #inputRefp />

                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="technicalSheetLicenseInput" class="form-label">
                      {{ 't-m-properties.t-technical-sheet-license' | translate }}
                    </label>
                    <input type="text" class="form-control" id="technicalSheetLicenseInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-technical-sheet-license' | translate }}"
                      formControlName="technicalSheetLicense" #inputRefp />

                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-3">
                  <div class="mb-3">
                    <label for="buildingLicenseInput" class="form-label">

                      {{ 't-m-properties.t-building-license' | translate }}
                    </label>
                    <input type="text" class="form-control" id="buildingLicenseInput"
                      placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-building-license' | translate }}"
                      formControlName="buildingLicense" #inputRefp />

                  </div>
                </div>
                <!--end col-->
              </div>
            </div>
          </div>
          <!--end row-->
        </div>
      </div>
    </div>
    <!--end row-->
    <div class="row mt-n4">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            {{'t-new-sales.t-finance-details' | translate}}
          </h5>
        </div>
        <div class="card-body pb-0">
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="priceInput" class="form-label">
                  {{ 't-m-properties.t-price' | translate }}
                </label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select [items]="currencies" [multiple]="false" bindLabel="currencyCode" bindValue="id"
                    placeholder="{{ 't-general.t-select' | translate }}" formControlName="currency" [clearable]="false">
                  </ng-select>
                  <input type="text" class="form-control" mask="separator" thousandSeparator=" " id="priceInput"
                    suffix=" {{getSuffix()}}"
                    placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-price' | translate }}"
                    formControlName="price" #inputRefp>
                </div>
              </div>
            </div>

            <!--end col-->

            <div class="mb-3 col-lg-4 d-md-flex justify-content-around">
              <div class="w-50">
                <label for="inventoryValueInput" class="form-label">
                  {{'t-commission-type' | translate}}
                </label>
                <div class="form-check mb-1">
                  <input
                    [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                    class="form-check-input" [value]="true" type="radio" name="isPercentageCommission"
                    id="flexRadioDefault1" formControlName="isPercentageCommission">
                  <label
                    [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                    class="form-check-label" for="flexRadioDefault1">
                    {{form['businessType'].value != typeRent ? ('t-percentage' | translate) :
                    ('t-months-m' | translate)}}
                  </label>
                </div>
                <div class="form-check">
                  <input
                    [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                    class="form-check-input" [value]="false" type="radio" name="isPercentageCommission"
                    id="flexRadioDefault2" formControlName="isPercentageCommission">
                  <label class="form-check-label" for="flexRadioDefault2">
                    {{'t-fixed-value' | translate}}
                  </label>
                </div>
              </div>
              <div class="w-100">
                <label for="saleCommissionInput" class="form-label">
                  {{ 't-m-properties.t-sale-commission' | translate }}
                </label>
                <input
                  [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                  *ngIf="form['isPercentageCommission'].value && form['businessType'].value != typeRent" type="text"
                  class="form-control" suffix="%" id="saleCommissionInput" autocomplete="off" mask="separator"
                  thousandSeparator=" "
                  placeholder="{{'t-enter' | translate}} {{ 't-m-properties.t-sale-commission' | translate }}"
                  formControlName="saleCommission" />
                <input
                  [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                  *ngIf="form['isPercentageCommission'].value && form['businessType'].value == typeRent" type="number"
                  class="form-control" id="saleCommissionInput" autocomplete="off"
                  placeholder="{{'t-enter' | translate}} {{ 't-m-properties.t-sale-commission' | translate }}"
                  formControlName="saleCommission" />
                <input *ngIf="!form['isPercentageCommission'].value" type="text" class="form-control"
                  [attr.disabled]="(form['businessStatus'].value === saleId || rentIds.includes(form['businessStatus'].value)) && property?.saleInProgress ? true : null"
                  id="saleCommissionInput" suffix=" {{getSuffix()}}" autocomplete="off" mask="separator"
                  thousandSeparator=" "
                  placeholder="{{'t-enter' | translate}} {{ 't-m-properties.t-sale-commission' | translate }}"
                  formControlName="saleCommission" />
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="propertyvalueInput" class="form-label">
                  {{ 't-m-properties.t-condo-value' | translate }}
                </label>
                <input type="text" mask="separator" thousandSeparator=" " class="form-control" id="propertyvalueInput"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-condo-value' | translate }}"
                  formControlName="propertyValue" #inputRefp>
              </div>
            </div>
            <div *ngIf="form['businessType'].value != typeRent" class="col-md-8 mt-3">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center">{{'t-new-sales.t-payment-type' | translate}}</th>
                    <th class="text-center">{{'t-new-sales.t-value-type' | translate}}</th>
                    <th style="width: 15%" class="text-center">{{'t-new-sales.t-value' | translate}}
                    </th>
                    <th class="text-center">{{'t-new-sales.t-payment-moment' | translate}}</th>
                    <th class="text-center">{{'t-new-sales.t-agency-commission' | translate}} <span
                        class="badge badge-soft-primary ms-1 rounded-pill"
                        ngbTooltip="{{'t-new-sales.t-agency-commission-tooltip' | translate}}" placement="top">
                        ?
                      </span>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody cdkDropList [cdkDropListData]="paymentsConditions" (cdkDropListDropped)="drop($event)">
                  <tr cdkDrag *ngFor="let payment of paymentsConditions; let i = index">
                    <td
                      [ngStyle]="{'pointer-events': form['businessStatus'].value === saleId && property?.saleInProgress ? 'none' : null}"
                      class="text-center align-middle cursor-move" cdkDragHandle>
                      <i class="mdi mdi-drag"></i>
                    </td>
                    <td>
                      <ng-select [(ngModel)]="payment.type"
                        [disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : false"
                        [clearable]="false" [ngModelOptions]="{standalone: true}" [multiple]="false">
                        <ng-option [value]="'DEED'">{{'t-new-sales.t-deed' |
                          translate}}</ng-option>
                        <ng-option [value]="'SALE_AGREEMENT'">{{'t-new-sales.t-sale-agreement' |
                          translate}}</ng-option>
                        <ng-option [value]="'RESERVATION'">{{'t-new-sales.t-reservation' |
                          translate}}</ng-option>
                        <ng-option [value]="'SIGNAL'">{{'t-new-sales.t-signal' |
                          translate}}</ng-option>
                      </ng-select>
                    </td>
                    <td>
                      <ng-select
                        [disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : false"
                        [(ngModel)]="payment.valueType" [clearable]="false" [ngModelOptions]="{standalone: true}"
                        [multiple]="false">
                        <ng-option value="PERCENTAGE">{{'t-new-sales.t-percentage' |
                          translate}}</ng-option>
                        <ng-option value="FIXED">{{'t-new-sales.t-fixed' |
                          translate}}</ng-option>
                      </ng-select>
                    </td>
                    <td>
                      <input
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        type="text" mask="separator" [ngModelOptions]="{standalone: true}" thousandSeparator=" "
                        (input)="onPaymentChange(payment)" [suffix]="payment.valueType == 'PERCENTAGE' ? ' %' : ' €'"
                        class="form-control" [(ngModel)]="payment.value" />
                    </td>
                    <td>
                      <input
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        *ngIf="payment.type == 'DEED' || payment.type == 'SALE_AGREEMENT' || payment.type == 'RESERVATION'"
                        type="text" [attr.disabled]="true" [value]="getPaymentConditionText(payment.type) | translate"
                        class="form-control" />
                      <input
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        *ngIf="payment.type != 'DEED' && payment.type != 'SALE_AGREEMENT' && payment.type != 'RESERVATION'"
                        type="text" [ngModelOptions]="{standalone: true}" class="form-control"
                        [(ngModel)]="payment.paymentMoment" />
                    </td>
                    <td>
                      <input
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        type="text" mask="separator" [ngModelOptions]="{standalone: true}" thousandSeparator=" "
                        [suffix]=" ' %' " class="form-control" [(ngModel)]="payment.agencyValue" />
                    </td>
                    <td class="text-center align-middle">
                      <button
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        (click)="removePaymentCondition(i)" type="button" class="btn btn-sm btn-outline-danger">
                        <i class="mdi mdi-trash-can"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" class="text-center">
                      <button
                        [attr.disabled]="form['businessStatus'].value === saleId && property?.saleInProgress ? true : null"
                        (click)="addPaymentCondition()" type="button" class="btn btn-sm btn-outline-primary">
                        <i class="mdi mdi-plus"></i>
                        {{'t-new-sales.t-add-payment' | translate}}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="form['businessType'].value != typeRent" class="col-md-4 mb-3">
              <div class="bg-light card h-100">
                <div class="card-header bg-light">
                  <h5 class="card-title mb-0">
                    <i class="ri-secure-payment-line align-bottom me-1 text-muted"></i>
                    {{'t-new-sales.t-payment-conditions' | translate}}
                  </h5>
                </div>

                <div class="card-body p-0">
                  <div class="table-responsive h-100">
                    <table class="align-middle h-100 mb-0 table table-bordered table-sm">
                      <thead class="table-light">
                        <tr>
                          <th class="text-center">{{'t-new-sales.t-phase' | translate}}</th>
                          <th class="text-center">{{'t-new-sales.t-buyer-pays' | translate}}
                          </th>
                          <th class="text-center">{{'t-new-sales.t-agency-receive' |
                            translate}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let payment of paymentsConditions">
                          <!-- Coluna Fase -->
                          <td class="ps-3">
                            <i class="mdi {{getPaymentConditionIcon(payment.type)}} me-1"></i>
                            {{ getPaymentConditionText(payment.type) | translate }}
                          </td>

                          <!-- Coluna Comprador Paga -->
                          <td class="text-center">
                            {{ getPaymentConditionValue(payment) }}
                          </td>

                          <!-- Coluna Agência Recebe -->
                          <td class="text-center">
                            {{ getPaymentConditionAgencyValue(payment) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div *ngIf="form['businessType'].value != typeRent" class="col-lg-4">
                            <label for="saleCommissionInput1" class="form-label">
                                {{'t-properties-details.t-payment-method' | translate}}
                            </label>
                            <div class="values d-flex justify-content-between align-items-center mb-1">
                                <span class="fw-bold">{{'t-properties-details.t-pre-contract' | translate}}: <span
                                        class="fw-normal">{{form['methodPaymentCommission'].value}}%</span></span>
                                <span class="fw-bold">{{'t-properties-details.t-deed' | translate}}: <span
                                        class="fw-normal">{{100 -
                                        form['methodPaymentCommission'].value}}%</span></span>
                            </div>
                            <input type="range" min="0" max="100" formControlName="methodPaymentCommission"
                                class="form-range" id="customRange1">
                        </div> -->

            <!--end col-->
          </div>
        </div>
      </div>
    </div>
    <!--end row-->
    <div class="row mt-n4">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">
            {{ 't-m-properties.t-energetic-certification' | translate }}
          </h5>
        </div>
        <div class="card-body">
          <div class="row">
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="ecInput" class="form-label">
                  {{ 't-m-properties.t-energetic-class' | translate }}
                </label>
                <ng-select [items]="ec" [multiple]="false" bindLabel="description" bindValue="id"
                  (change)="onChangeEC($event)"
                  placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-energetic-class' | translate }}"
                  [clearable]="false" formControlName="ec"
                  [ngClass]="{ 'is-invalid': submitted && form['ec'].errors && form['ec'].errors['required'] }"
                  [ngClass]="{ 'is-warning': submitted && form['ec'].errors && form['ec'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['ec'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['ec'].errors['required']">
                    {{ 't-m-properties.t-energetic-class' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="ecnumberInput" class="form-label">
                  {{ 't-m-properties.t-energetic-number' | translate }}
                </label>
                <input type="text" class="form-control" id="ecnumberInput"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-energetic-number' | translate }}"
                  formControlName="ecNumber" #inputRefp>

              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="expirationdateInput" class="form-label">
                  {{ 't-m-properties.t-expiration-date-EC' | translate }}
                </label>
                <input class="form-control flatpickr-input" type="text"
                  placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-expiration-date-EC' | translate }}"
                  mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true" [dateFormat]="'d/m/Y'" formControlName="ecExpirationDate"
                  #inputRefp />
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4" *ngIf="legislations?.length > 0">
              <div class="mb-3">
                <label for="legislationsInput" class="form-label">
                  {{ 't-m-properties.t-legislation' | translate }}
                </label>
                <ng-select [multiple]="false"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-legislation' | translate }}"
                  formControlName="legislation" [clearable]="false" class="details-legislation">
                  <ng-option *ngFor="let legislation of legislations" [value]="legislation.id">
                    {{ 't-ec-legislations.t-' + legislation.key | translate}}
                  </ng-option>
                </ng-select>

              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="renewableEnergyInput" class="form-label">
                  {{ 't-m-properties.t-renewable-energy' | translate }}
                </label>
                <input class="form-control" type="text" mask="separator" thousandSeparator=" " suffix="%"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-renewable-energy' | translate }}"
                  formControlName="renewableEnergy" #inputRefp />
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="carbonInput" class="form-label">
                  {{ 't-m-properties.t-carbon-emission' | translate }}
                </label>
                <input class="form-control" type="text" mask="separator" thousandSeparator=" "
                  suffix=" {{'t-ton-year' | translate}}"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-carbon-emission' | translate }}"
                  formControlName="carbonEmissions" #inputRefp />
              </div>
            </div>
            <!--end col-->
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!--end row-->
    <div class="row mt-n4">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">{{ 't-m-properties.t-mediation-agreement' | translate }}</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="contractNumber" class="form-label">
                  {{'t-contract-number' | translate}}
                </label>
                <input class="form-control" type="text" placeholder="{{ 't-contract-number' | translate }}"
                  formControlName="contractNumber" [ngModel]="detailsForm?.data?.contractNumber?.toString()">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="startdateInput" class="form-label">
                  {{ 't-m-properties.t-start-date' | translate }}
                </label>
                <input class="form-control flatpickr-input" type="text"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-start-date' | translate }}"
                  mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true" [monthSelectorType]="'static'" [dateFormat]="'d/m/Y'"
                  formControlName="startDateMediation" (flatpickrChange)="onChangeStartDateMediation($event)" #inputRefp>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="enddateInput" class="form-label">
                  {{ 't-m-properties.t-end-date' | translate }}
                </label>
                <input class="form-control flatpickr-input" type="text"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-end-date' | translate }}"
                  mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true" [dateFormat]="'d/m/Y'" formControlName="endDateMediation"
                  id="endDateMediation"
                  [attr.disabled]="this.propertyDetailsForm.get('defineEndDate')?.value > 0?true:null"
                  [attr.style]="this.propertyDetailsForm.get('defineEndDate')?.value > 0?'background-color:#eff2f7;cursor: auto;':null"
                  #inputRefp>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="defEnddateInput" class="form-label">
                  {{ 't-m-properties.t-define-end-date' | translate }}
                </label>
                <ng-select [items]="[3,6,12,24,36]" [multiple]="false" bindLabel="name"
                  (change)="onChangeDefineDate($event)" bindValue="id"
                  placeholder="{{ 't-general.t-select' | translate }}" formControlName="defineEndDate"></ng-select>
              </div>
            </div>
            <!--end col-->
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!--end row-->
    <!-- Modal Sale -->
    <ng-template #content role="document" let-modal>
      <div class="modal-header p-3 ps-4 bg-soft-primary">
        <div class="d-flex align-items-center gap-2">
          <h5 class="modal-title" id="inviteMembersModalLabel">
            {{ "t-new-sales.t-sale-details" | translate }}
          </h5>
          <div *ngIf="property?.saleInProgress"
            class="align-items-center badge badge-soft-warning d-flex fs-12 warning-badge">
            <i class="ri-error-warning-line text-warning me-1"></i>
            <span>{{ 't-new-sales.t-sale-details-warning' | translate }}</span>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <app-sale-form
          [formGroup]="propertyDetailsForm"
          [typeRent]="typeRent"
          [isRentMode]="false"
          [property]="property"
          [paymentsConditions]="paymentsConditions ?? []"
          [pathProfileImage]="pathProfileImage"
          [openNewAgent]="openNewAgent"
          [selected]="selected"
          [agentsExceptListing]="agentsExceptListing"
          [agentsExceptSelling]="agentsExceptSelling"
          [showAgentSections]="true"
          [disableBySaleInProgress]="false"
          [allowSharedSellerHide]="true"
          [getAgentsFn]="saleFormGetAgentsFn"
          [getStoreByIdFn]="saleFormGetStoreByIdFn"
          [getSuffixFn]="saleFormGetSuffixFn"
          (addAgent)="addAgent($event)"
          (removeAgent)="removeAgent($event.type, $event.id)"
          (changeAgent)="onChangeAgent($event.id, $event.type)"
          (addPaymentCondition)="addPaymentCondition()"
          (removePaymentCondition)="removePaymentCondition($event)"
          (paymentChange)="onPaymentChange($event)"
          (paymentDropped)="drop($event)">
        </app-sale-form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary w-xs" (click)="modal.dismiss()">
          {{ "t-close" | translate }}
        </button>
      </div>
    </ng-template>

    <!-- Modal Rent -->
    <ng-template #contentRent role="document" let-modal>
      <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
          {{ "t-new-sales.t-sale-details" | translate }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <app-sale-form
          [formGroup]="propertyDetailsForm"
          [typeRent]="typeRent"
          [isRentMode]="true"
          [property]="property"
          [paymentsConditions]="paymentsConditions ?? []"
          [pathProfileImage]="pathProfileImage"
          [openNewAgent]="openNewAgent"
          [selected]="selected"
          [agentsExceptListing]="agentsExceptListing"
          [agentsExceptSelling]="agentsExceptSelling"
          [showAgentSections]="true"
          [disableBySaleInProgress]="true"
          [allowSharedSellerHide]="false"
          [getAgentsFn]="saleFormGetAgentsFn"
          [getStoreByIdFn]="saleFormGetStoreByIdFn"
          [getSuffixFn]="saleFormGetSuffixFn"
          (addAgent)="addAgent($event)"
          (removeAgent)="removeAgent($event.type, $event.id)"
          (changeAgent)="onChangeAgent($event.id, $event.type)"
          (addPaymentCondition)="addPaymentCondition()"
          (removePaymentCondition)="removePaymentCondition($event)"
          (paymentChange)="onPaymentChange($event)"
          (paymentDropped)="drop($event)">
        </app-sale-form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary w-xs" (click)="modal.dismiss()">
          {{ "t-close" | translate }}
        </button>
      </div>
    </ng-template>
  </form>
</ngx-simplebar>

<app-toasts></app-toasts>
